import {TextureType} from "@generated"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {OperatorExecutionMode} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator"

export class ImageOpNodeBagSet {
    debugId?: string

    dispose() {
        this._imageOpNodeBagByTextureTypeByMode.forEach((imageOpNodeBagByTextureType) =>
            imageOpNodeBagByTextureType.forEach((imageOpNodeBag) => imageOpNodeBag.dispose()),
        )
        this._imageOpNodeBagByTextureTypeByMode.clear()
    }

    getImageOpNodeBag(mode: OperatorExecutionMode, textureType: TextureType): ImageOpNodeBag {
        let imageOpNodeBagByMode = this._imageOpNodeBagByTextureTypeByMode.get(mode)
        if (!imageOpNodeBagByMode) {
            imageOpNodeBagByMode = new Map<TextureType, ImageOpNodeBag>()
            this._imageOpNodeBagByTextureTypeByMode.set(mode, imageOpNodeBagByMode)
        }
        let imageOpNodeBag = imageOpNodeBagByMode.get(textureType)
        if (!imageOpNodeBag) {
            imageOpNodeBag = new ImageOpNodeBag(this.debugId ? `${this.debugId}.${textureType}` : textureType)
            imageOpNodeBagByMode.set(textureType, imageOpNodeBag)
        }
        return imageOpNodeBag
    }

    private _imageOpNodeBagByTextureTypeByMode = new Map<OperatorExecutionMode, Map<TextureType, ImageOpNodeBag>>()
}
